// TODO: this is not working well
interface ConversationRelationships {
  messages: Message[]
  users: User[]
}

export async function fetchConversations() {
  const {
    data,
    attributes: conversations,
    relationships,
    pending,
    error,
    refresh,
  } = await useApiFetch<Conversation[], ConversationRelationships>(
    '/api/v1/conversations?include=messages,users',
    {},
    false,
  )

  const mappedConversations = computed(() => {
    if (!data.value) {
      return []
    }
    return data.value?.data.map((conversation) => {
      const rel = conversation.relationships as any

      const userIds = rel.users.data as { id: string, type: string }[]
      const messageIds = rel.messages.data as { id: string, type: string }[]

      // console.log(`data conversation`, conversation, rel)
      // console.log(`users`, userIds)

      // TODO: fix typing properly
      const included = data.value?.included as unknown as {
        id: id
        type: string
      }[]

      const mappedUsers = userIds.map(({ id, type }) => {
        if (type == 'public_user') {
          const user = included.find(i => i.id == id && i.type == type) as any
          // console.log(`user`, id, type, user)
          return user.attributes as User
        }
        else {
          console.error(`unknown type`, type)
          return undefined
        }
      })

      const mappedMessages = messageIds.map(({ id, type }) => {
        if (type == 'message') {
          const message = included.find(
            i => i.id == id && i.type == type,
          ) as any
          // console.log(`message`, id, type, message)
          return message.attributes as Message
        }
        else {
          console.error(`unknown type`, type)
          return undefined
        }
      })

      return {
        ...conversation.attributes,
        users: mappedUsers,
        messages: mappedMessages,
      } as unknown as Conversation // AARGH
    })
  })

  // conversations.value.forEach((conversation) => {
  //   const rels = conversation.relationships as ConversationRelationships
  //   // const conversationMessages = conversation.relationships.map(
  //   //   (m) => m['id'] === relationships.value.messages,
  //   // )
  // })

  // console.log(`Conversation data`, data.value)
  // console.log(`Conversation relationships`, relationships.value)

  return { data, conversations, mappedConversations, pending, error, refresh }
}

interface ConversationPayload {
  body: string
}

export async function createConversationMessage(
  conversationId: id,
  attributes: ConversationPayload,
) {
  const { data: message } = await $api<JSONAPIResponse<Message>>(
    `/api/v1/conversations/${conversationId}/send_message/`,
    {
      method: 'POST',
      body: {
        data: {
          type: 'message',
          attributes: attributes,
        },
      },
    },
  )

  return message
}

export interface CreateConversationPayload {
  subject: string
  userIds: id[]
  body: string
}

export async function createConversation(
  attributes: CreateConversationPayload,
) {
  const { data: conversation } = await $api<JSONAPIResponse<Conversation>>(
    `/api/v1/conversations/`,
    {
      method: 'POST',
      body: {
        data: {
          type: 'conversation',
          attributes: attributes,
        },
      },
    },
  )

  return conversation
}
